import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { ContributionSetupComponent, ContributionSetupConfig } from '../../shared/components/contribution-setup/contribution-setup.component';
import { StepperStep } from '../../shared/components/primeng';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-org-admin-add-dataset',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    OrgAdminSidebarComponent,
    ContributionSetupComponent,
  ],
  templateUrl: './add-dataset.component.html',
  styleUrl: './add-dataset.component.scss',
})
export class OrgAdminAddDatasetComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private destroy$ = new Subject<void>();
  private readonly ROUTE_BASE = '/org-admin/add-dataset';
  private readonly LOCAL_STORAGE_KEY = 'datasetFormData';

  config: ContributionSetupConfig = {
    type: 'dataset',
    routeBase: 'org-admin/add-dataset',
    setupTitle: 'Setup your Datasets',
    titlePlaceholder: 'Enter dataset title',
    localStorageKey: 'datasetFormData',
    stepperSteps: [
      {
        key: 'step1',
        label: 'Setup your datasets',
      },
      {
        key: 'step2',
        label: 'Enter Metadata',
      },
      {
        key: 'step3',
        label: 'Additional Info',
      },
      {
        key: 'step4',
        label: 'Upload Data',
      },
    ],
    routes: [
      'org-admin/add-dataset',
      'org-admin/add-dataset/metadata',
      'org-admin/add-dataset/additionalInfo',
      'org-admin/add-dataset/uploads'
    ]
  };

  ngOnInit(): void {
    // Check current route on init - if not in add-dataset flow, clear localStorage
    this.checkAndClearLocalStorage();
    
    // Listen to router navigation events
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: any) => {
        this.checkAndClearLocalStorage(event.urlAfterRedirects || event.url);
      });
  }

  private checkAndClearLocalStorage(url?: string): void {
    const currentUrl = url || this.router.url;
    
    // Check if current route is part of the add-dataset flow
    const isInAddDatasetFlow = this.config.routes.some(route => {
      const routePath = `/${route}`;
      return currentUrl === routePath || currentUrl.startsWith(`${routePath}/`);
    });
    
    if (!isInAddDatasetFlow) {
      // User is not in the add-dataset flow, clear localStorage
      localStorage.removeItem(this.LOCAL_STORAGE_KEY);
      console.log('Cleared datasetFormData from localStorage - not in add-dataset flow. Current URL:', currentUrl);
    }
  }

  ngOnDestroy(): void {
    // Check if we're still in the flow before destroying
    // If not, clear localStorage as a safety measure
    this.checkAndClearLocalStorage();
    
    // Clean up subscription
    this.destroy$.next();
    this.destroy$.complete();
  }
}
